import { render, staticRenderFns } from "./TokenPayment.vue?vue&type=template&id=3cdc85c2&scoped=true"
import script from "./TokenPayment.vue?vue&type=script&lang=js"
export * from "./TokenPayment.vue?vue&type=script&lang=js"
import style0 from "./TokenPayment.vue?vue&type=style&index=0&id=3cdc85c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cdc85c2",
  null
  
)

export default component.exports